import React, { useState } from "react";
import IncidentTable from "./IncidentTable";
import EventTable from "./EventTable";
import DMSHeader from "../DMSHeader/DMSHeader";

const IncidentManagementt = () => {
  const [selectedIncidentId, setSelectedIncidentId] = useState(null);
  const [refreshIncidentTable, setRefreshIncidentTable] = useState(false);

  const handleEventDeleted = () => {
    setRefreshIncidentTable((prev) => !prev); // Toggle to trigger refresh
  };

  return (
    <>
      <div style={{ margin: "8px" }}>
        <DMSHeader
          title={
            // view ? t('View Contact Detaiils') :
            "Incident List"
          }
          showmenu={true}
          showImportDropDownLabel={false}
          style={{ margin: "8px" }}
        />
        <div
          style={{
            fontFamily: "Arial, sans-serif",
            marginTop: "10px",
            backgroundColor: "#252b48",
            borderRadius: "10px",
          }}
        >
          <IncidentTable
            onRowClick={(id) => setSelectedIncidentId(id)}
            selectedRowId={selectedIncidentId}
            refreshTrigger={refreshIncidentTable}
          />
        </div>
        <div
          style={{
            fontFamily: "Arial, sans-serif",
            marginTop: "20px",
            backgroundColor: "#252b48",
            borderRadius: "10px",
          }}
        >
          <EventTable
            selectedIncidentId={selectedIncidentId}
            onEventDeleted={handleEventDeleted}
          />
        </div>
      </div>
    </>
  );
};

export default IncidentManagementt;
